import {gsap} from 'gsap'
import ScrollTrigger from 'gsap/ScrollTrigger'
import {CountUp} from "countup.js";

export class CountNumber {
  constructor() {
    this._numbers = document.querySelectorAll('[animation-number]')

    if (!this._numbers.length) return;

    this.init()
  }

  init() {
    gsap.registerPlugin(ScrollTrigger)

    this._numbers.forEach(number => {
      ScrollTrigger.create({
        trigger: number,
        start: 'top 100%',
        once: true,
        onEnter: (st) => this.countNumber(st),
      })
    })
  }

  countNumber(el) {
    const target = el.trigger
    const raw = (target.getAttribute('animation-number') || target.textContent || '').trim()
    const match = raw.match(/^(\D*?)([\d][\d.,\s]*)(\D*)$/)

    if (!match) return

    const prefix = match[1] || ''
    const endVal = parseFloat(match[2].replace(/\s/g, '').replace(',', '.'))
    const suffix = match[3] || ''

    if (Number.isNaN(endVal)) return

    const count = new CountUp(target, endVal, {
      duration: 4,
      prefix,
      suffix,
    })

    if (!count.error) {
      count.start()
    }
  }
}
